/* eslint no-bitwise: ["error", { "allow": ["&"] }] */
// using helper function to localize the linting rules
function CheckIntegrationSetting(integrationElement, integrationMode) {
  return !(integrationElement & integrationMode);
}

export default CheckIntegrationSetting;
